import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useProviderStore = create(
  persist(
    (set) => ({
      // ✅ full provider details
      provider: {
        _id: '',
        name: '',
        address: '',
        phone: '',
        description: '',
        workingHours: { start: '', end: '' },
        owner: '',
      },

      // ✅ set a single field
      setField: (key, value) =>
        set((state) => ({
          provider: { ...state.provider, [key]: value },
        })),

      // ✅ update multiple fields at once
      updateFields: (updates) =>
        set((state) => ({
          provider: { ...state.provider, ...updates },
        })),

      // ✅ reset to empty
      reset: () =>
        set({
          provider: {
            _id: '',
            name: '',
            address: '',
            phone: '',
            description: '',
            workingHours: { start: '', end: '' },
            owner: '',
          },
        }),
    }),
    {
      name: 'providerInfo', // saved in localStorage
    }
  )
);
